import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ completed }) => ({
  color: "white",
  backgroundColor: completed ? "#2ec4b6" : "#2ec4b6",
  '&:hover': {
    backgroundColor: completed ? "#25a8a0" : "#25a8a0",
  },
  "&:disabled": {
    color: "#999",
    backgroundColor: "#f0f0f0",
  },
  borderRadius: '8px',
  fontWeight: 600,
  textTransform: 'none',
  padding: '12px 24px',
}));

const AnswerSubmitButton = ({ disabled, text, onClick, completed }) => {
  return (
    <StyledButton
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      completed={completed}
    >
      {text}
    </StyledButton>
  );
};

export default AnswerSubmitButton;
